// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__IqQCs","tab":"styles_tab__cYzay","active":"styles_active__cIqpn","activeTab":"styles_activeTab__BP3rJ","tabs-white":"styles_tabs-white__VwWU0"};